import { Route } from "react-router-dom";
import UsersScreen from "../../../container/System/UsersScreen";
import CreateUsersContainer from "../../../container/System/UsersScreen/CreateUsers";
import { APP_URLS } from "../../../utils/constant";

const UsersRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SYSTEM_USERS.HOME}
          element={<UsersScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SYSTEM_USERS.CREATE}
          element={<CreateUsersContainer />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SYSTEM_USERS.EDIT}
          element={<CreateUsersContainer isEdit={true} />}
        />
      )}
    </>
  );
};

export default UsersRoutes;
